import { DocumentsOpenedModel } from "../inventory/documents-opened.model";

export class RentalPeriodModel {
  rentalPeriodId: number = 0;
  branchId: number = 0;
  year: number = 0;
  period: number = 0;
  initialDate: Date = new Date("0000-00-00");
  finalDate: Date = new Date("0000-00-00");
  active: boolean = true;
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;

  documentsOpened: Array<DocumentsOpenedModel> = new Array<DocumentsOpenedModel>();
}
